export class Settings{
    static baseHost(): string{
        return "https://kursufa.ru/api/";
    }

    static baseUrl(): string{
        return "https://kursufa.ru/api/";
    }
}